import { hubDay, hubPeriod, moveHubDay } from "./customerHubActivityData"
import { customerHubDate, customerHubPeriod } from "./customerHubNavigation"

export function shiftTrainingPeriod(period, anchor, direction) {
  if (!customerHubDate(anchor) || ![-1, 1].includes(direction) || period === "all") return anchor
  const range = hubPeriod(customerHubPeriod(period), anchor)
  if (period === "week") return moveHubDay(range.from, direction * 7)
  const date = new Date(`${range.from}T12:00:00Z`)
  if (period === "year") date.setUTCFullYear(date.getUTCFullYear() + direction)
  else date.setUTCMonth(date.getUTCMonth() + direction)
  return date.toISOString().slice(0, 10)
}

// Ongoing periods compare only the elapsed calendar days with the same portion
// of the preceding period. Completed periods compare their full ranges.
export function trainingComparisonRange(period, anchor, today = hubDay()) {
  if (period === "all" || !customerHubDate(today)) return null
  const current = hubPeriod(customerHubPeriod(period), anchor)
  if (current.from > today) return null
  const previous = hubPeriod(current.period, shiftTrainingPeriod(current.period, current.from, -1))
  const partial = today < current.to
  const elapsed = Math.round((Date.parse(today) - Date.parse(current.from)) / 86400000)
  const sameDaysEnd = partial ? moveHubDay(previous.from, elapsed) : previous.to
  return { from: previous.from, to: sameDaysEnd < previous.to ? sameDaysEnd : previous.to, partial,
    label: { week: "Vorwoche", month: "Vormonat", year: "Vorjahr" }[current.period] }
}

export function trainingProgressBuckets(completed, range, today = hubDay()) {
  const days = completed.map(item => item.date).filter(customerHubDate).sort()
  const from = range.period === "all" ? days[0] : range.from
  const to = range.period === "all" ? days[days.length - 1] : range.to
  if (!customerHubDate(from) || !customerHubDate(to) || from > to) return []
  const buckets = []
  for (let start = from; start <= to;) {
    let end, label
    if (range.period === "week") {
      end = start
      label = new Intl.DateTimeFormat("de-CH", { weekday: "short", timeZone: "UTC" }).format(new Date(start))
    } else if (range.period === "month") {
      end = moveHubDay(start, 6)
      if (end > to) end = to
      label = `${Number(start.slice(8))}–${Number(end.slice(8))}`
    } else {
      end = hubPeriod(range.period === "all" ? "year" : "month", start).to
      if (end > to) end = to
      label = range.period === "all" ? start.slice(0, 4) : new Intl.DateTimeFormat("de-CH", { month: "short", timeZone: "UTC" }).format(new Date(start))
    }
    buckets.push({ from: start, to: end, label, count: days.filter(day => day >= start && day <= end).length, future: start > today })
    start = moveHubDay(end, 1)
  }
  return buckets
}
